import React from "react";
import { Button } from "@c4c-web/ui";
import type { TranslationFn } from "../../../types";

interface IConfirmAddressFooterProps {
  disableSubmitButton: boolean;
  handleCancel: () => void;
  handleSubmit: () => void;
  t: TranslationFn;
}

export const ConfirmAddressFooter: React.FC<IConfirmAddressFooterProps> = ({
  disableSubmitButton,
  handleCancel,
  handleSubmit,
  t,
}) => (
  <div className="flex w-full gap-sm">
    <Button className="w-full" onClick={handleCancel} size="lg" variant="ghost">
      {t("addressJourney.cancel")}
    </Button>
    <Button
      className="w-full"
      disabled={disableSubmitButton}
      onClick={handleSubmit}
      size="lg"
    >
      {t("addressJourney.saveAndContinue")}
    </Button>
  </div>
);
